import { render, staticRenderFns } from "./DatevDownload.vue?vue&type=template&id=e546ec20&scoped=true"
import script from "./DatevDownload.vue?vue&type=script&lang=js"
export * from "./DatevDownload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e546ec20",
  null
  
)

export default component.exports